import { API_PREFIX } from './constant'
import { Request } from './request'

export interface MemberBenefitsPageParams {
  current?: number
  size?: number
  name?: string
  materialsCategory?: any
  category?: string
  itemName?: string
}

export function getMemberBenefitsPage(params: MemberBenefitsPageParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/materialscatalog/goodsManagement`,
    method: 'GET',
    params,
  }
}

export interface TreatmentBenefitsPageParams {
  current?: number
  size?: number
  name?: string
  billingCategory?: string
}

export function getTreatmentBenefitsPage(params: TreatmentBenefitsPageParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/treatmentServiceCatalog/page`,
    method: 'GET',
    params: {
      ...params,
      state: 1,
    },
  }
}

// ========== 会员权益接口 ==========

export interface MemberInterestPageParams {
  current?: number
  size?: number
  name?: string
  type?: string
  discountType?: string
  billingCategoryFlag?: boolean
}

export function getMemberInterestPage(params: MemberInterestPageParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/memberInterest/page`,
    method: 'GET',
    params,
  }
}

export interface MemberInterestDetailParams {
  id: string | number
}

export function getMemberInterestDetail(params: MemberInterestDetailParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/memberInterest/detail`,
    method: 'GET',
    params,
  }
}

export function submitMemberInterest(data: any): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/memberInterest/update`,
    method: 'POST',
    body: data,
  }
}

export function submitMemberInterestBatch(data: any): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/memberInterest/submit`,
    method: 'POST',
    body: data,
  }
}

export interface MemberInterestExceptionPageParams {
  billingCategory: string
  catalogType: number
}

export function getMemberInterestExceptionPage(params: MemberInterestExceptionPageParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/memberInterestException/backInfo`,
    method: 'GET',
    params,
  }
}

export function submitMemberInterestException(data: any): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/memberInterestException/submit`,
    method: 'POST',
    body: data,
  }
}

export function deleteMemberInterest(data: { id: string | number }): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/memberInterest/delete`,
    method: 'GET',
    params: data,
  }
}
